import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { LoadCadastro } from '../pages/financeiro/documentos/utils/LoadCadastro';

const DataCadastroContext = createContext();

export const DataCadastroProvider = ({ children }) => {
  const [dataCadastro, setDataCadastro] = useState(null);

  const loadDataCadastro = useCallback(async () => {

    setDataCadastro({
      financeiro_conta: await LoadCadastro('/cadastro/financeiro_conta'),
      financeiro_movimentacao_tipo: await LoadCadastro('/cadastro/financeiro_movimentacao_tipo'),
      produto_servico: await LoadCadastro('/cadastro/produto_servico'),      
      produto_servico_classificacao: await LoadCadastro('/cadastro/produto_servico_classificacao'),
      centro_de_custo: await LoadCadastro('/cadastro/centro_de_custo'),
      unidade_de_medida: await LoadCadastro('/cadastro/unidade_de_medida'),
    });
  }, []);

  useEffect(() => {
    loadDataCadastro();
  }, [loadDataCadastro]);

  return (
    <DataCadastroContext.Provider value={{ dataCadastro, reloadDataCadastro: loadDataCadastro }}>
      {children}
    </DataCadastroContext.Provider>
  );
};

export const useDataCadastro = () => {
  const context = useContext(DataCadastroContext);
  if (!context) {
    throw new Error('useDataCadastro deve ser usado dentro de um DataCadastroProvider');
  }
  return context;
};
